package provider

import kotlinx.browser.*
import kotlinx.coroutines.suspendCancellableCoroutine
import kotlin.coroutines.resume

private external interface Position {
    val coords: Coords

}

private external interface Coords {
    val latitude: Double
    val longitude: Double
}

class ExternalsProvider : CommonExternalsProvider() {
    override fun openInBrowser(url: String) {
        window.open(url = url, target = "_blank")
    }

    override fun isGeolocationAvailable(): Boolean = runCatching {
        window.navigator.asDynamic().geolocation != null
    }.getOrNull() ?: false

    override suspend fun getGeoLocation(): Pair<Double, Double>? = suspendCancellableCoroutine { continuation ->
        window.navigator.asDynamic().geolocation.getCurrentPosition({ position: Position ->
            continuation.resume(position.coords.latitude to position.coords.longitude)
        }, {
            continuation.resume(null)
        })
    }
}
